import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import { Grid } from "@mui/material";
import IDMELogo from "../../../images/icons/IDme.svg";
import DigitalRxLogo from "../../../images/icons/DRxLogo.svg";
import { useEffect, useState } from "react";
import { primaryColor } from "../../../Theme";
import {
  check2FAEvent,
  saveAsPreferenceApi,
  startMFAEvent,
} from "../../../Apis/Idme2FA";
import { CircularProgress } from "@mui/material";
import { YSButton } from "../../../uikit/YSButton";
import { useDispatch, useSelector } from "react-redux";
import { setSteps } from "../../../Redux/Slice/IdmeSlice";

type TypesOfData = {
  uuid: string;
  status: string;
  expires: string;
};

export default function CheckMFAEventStatus({
  handleHidePopupClick,
  setVerifiedByIdmeUuid,
  userUuidData,
  setIsBack,
}: any) {
  const IdmePreferenceData = useSelector((state: any) => {
    return { ...state.IdmeSlice };
  }); //redux data
  const dispatch = useDispatch();
  const [seconds, setSeconds] = useState(300);
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<TypesOfData | null>(null);
  const [startMfaErrorMessage, setStartMfaErrorMessage] = useState<
    string | null
  >(null);

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins > 0) {
      return `${mins}:${secs}`;
    } else {
      return `${secs}`;
    }
  };
  const submitPreferenceRoute = async () => {
    try {
      const body = {
        settingType: "MFA_ROUTE",
        enabled: true,
        savedPreference: IdmePreferenceData?.route,
        doctorId: localStorage.getItem("doctorId"),
        userId: localStorage.getItem("LoginUserID"),
      };
      const result = await saveAsPreferenceApi(body);
      if (result?.data?.digitalRxStatusCode === 200) {
        console.log("🚀 ~ submitPreference ~ result?.data:", result?.data);
      }
    } catch (error) {
      console.error("🚀 ~ submitPreference ~ error:", error);
    }
  };

  const submitPreferenceSetup = async () => {
    try {
      const body = {
        settingType: "MFA_SETUP",
        enabled: true,
        savedPreference: IdmePreferenceData?.setup,
        settingIdentifier: IdmePreferenceData?.fetch2FaUuid,
        doctorId: localStorage.getItem("doctorId"),
        userId: localStorage.getItem("LoginUserID"),
      };
      const result = await saveAsPreferenceApi(body);
      if (result?.data?.digitalRxStatusCode === 200) {
        console.info("🚀 ~ submitPreference ~ result?.data:", result?.data);
      }
    } catch (error) {
      console.error("🚀 ~ submitPreferenceSetup ~ error:", error);
    }
  };
  useEffect(() => {
    const intervalId = setInterval(() => {
      setSeconds((prev) => {
        if (prev === 0) {
          clearInterval(intervalId);
          dispatch(setSteps("sessionTimeOut"));
          return 0;
        } else {
          return prev - 1;
        }
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const start2FAEvent = async () => {
      try {
        const params: any = new URLSearchParams();
        params.append("userUUID", localStorage.getItem("userIdmeUuid"));
        params.append("setupId", IdmePreferenceData?.fetch2FaUuid);
        const result = await startMFAEvent(params);
        if (result.status === 200) {
          setData(result?.data);
          setLoading(false);
          setStartMfaErrorMessage(null);
        } else {
          setData(null);
          setLoading(false);
          setStartMfaErrorMessage(result?.data?.message);
        }
      } catch (error: any) {
        setData(null);
        setLoading(false);
        setStartMfaErrorMessage("Something went wrong, please try again!");
      }
    };
    start2FAEvent();
  }, [IdmePreferenceData?.fetch2FaUuid]);

  useEffect(() => {
    if (!data) {
      return;
    }
    const intervalId = setInterval(() => {
      const checkStatusOfEvent = async () => {
        try {
          const params: any = new URLSearchParams();
          params.append("userUUID", localStorage.getItem("userIdmeUuid"));
          params.append("eventId", data?.uuid);
          const result = await check2FAEvent(params);
          if (result.status === 200 && result.data?.status === "accepted") {
            clearInterval(intervalId);
            dispatch(setSteps("success"));
            setTimeout(() => {
              if (
                IdmePreferenceData?.routeEnable === true &&
                IdmePreferenceData?.setupEnable === true &&
                IdmePreferenceData?.route !==
                  userUuidData?.savedPreferenceForRoute?.toString() &&
                IdmePreferenceData?.setup !==
                  userUuidData?.savedPreferenceForSetUp?.toString()
              ) {
                Promise.all([
                  submitPreferenceSetup(),
                  submitPreferenceRoute(),
                  setVerifiedByIdmeUuid(result.data?.uuid),
                  handleHidePopupClick(),
                ]);
              } else if (
                IdmePreferenceData?.routeEnable === true &&
                IdmePreferenceData?.route !==
                  userUuidData?.savedPreferenceForRoute?.toString()
              ) {
                Promise.all([
                  submitPreferenceRoute(),
                  setVerifiedByIdmeUuid(result.data?.uuid),
                  handleHidePopupClick(),
                ]);
              } else if (
                IdmePreferenceData?.setupEnable === true &&
                IdmePreferenceData?.setup !==
                  userUuidData?.savedPreferenceForSetUp?.toString()
              ) {
                Promise.all([
                  submitPreferenceSetup(),
                  setVerifiedByIdmeUuid(result.data?.uuid),
                  handleHidePopupClick(),
                ]);
              } else {
                Promise.all([
                  setVerifiedByIdmeUuid(result.data?.uuid),
                  handleHidePopupClick(),
                ]);
              }
            }, 2000);
          } else if (result.data?.status === "failed") {
            clearInterval(intervalId);
            dispatch(setSteps("fail"));
          }
        } catch (error) {
          clearInterval(intervalId);
          dispatch(setSteps("fail"));
        }
      };
      checkStatusOfEvent();
    }, 3000);

    return () => clearInterval(intervalId);
  }, [data]);

  if (loading) {
    return (
      <>
        <Grid container className="logos" height={384}>
          <Grid item>
            <CircularProgress color="primary" />
          </Grid>
        </Grid>
      </>
    );
  }

  if (startMfaErrorMessage) {
    return (
      <>
        <Grid container className="logos" flexDirection={"column"} height={384}>
          <Grid item>
            <Box className="logos">
              <img src={IDMELogo} alt="ID.me" height={30} />
              <Typography
                component={"div"}
                color={"slategrey"}
                margin={0}
                padding={0}
                variant={"h3"}
                fontWeight={600}
              >
                +
              </Typography>
              <img src={DigitalRxLogo} alt="Digital_Rx" height={30} />
            </Box>
          </Grid>
          <Grid item>
            <Typography variant="h5" color={"error"}>
              {startMfaErrorMessage}
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  }

  return (
    <>
      <Grid container spacing={2} height={400}>
        <Grid item xs={12}>
          <Box className="logos">
            <img src={IDMELogo} alt="ID.me" height={30} />
            <Typography
              component={"div"}
              color={"slategrey"}
              margin={0}
              padding={0}
              variant={"h3"}
              fontWeight={600}
            >
              +
            </Typography>
            <img src={DigitalRxLogo} alt="Digital Rx" height={30} />
          </Box>
        </Grid>
        <Grid item xs={12} textAlign="center" marginY={2}>
          <Box className="timer">
            <Typography
              component={"div"}
              variant={"h1"}
              color={seconds === 0 ? "error" : primaryColor}
            >
              {formatTime(seconds)}
            </Typography>
          </Box>

          <Typography color="primary" variant="subtitle1" marginY={2}>
            Approve sign-in using your ID.me Authenticator app on device:{" "}
            {IdmePreferenceData?.deviceName ?? ""}
          </Typography>
          <Typography variant="body1" marginY={2}>
            Please check your mobile notification or open the app and approve
            the sign-in request.
          </Typography>
          <YSButton
            children="Back"
            variant="outlined"
            type="button"
            onClick={() => {
              dispatch(setSteps("three"));
              setIsBack(true);
            }}
            size="large"
            className=""
          />
        </Grid>
      </Grid>
    </>
  );
}
